export default {
	inserted(el) {
		// Find the actual input element
		const inputEl = el.querySelector('input');

		// Function to format value to two decimal places
		const formatValue = () => {
			const value = parseFloat(inputEl.value);
			if(Number.isNaN(value)) return;
			inputEl.value = value.toFixed(2);
		};

		// Disable mouse scroll on the input field
		inputEl.addEventListener('wheel', (e) => {
			e.preventDefault();
		});

		// Format the value when the input field loses focus
		inputEl.addEventListener('blur', formatValue);

		// Listen for up/down arrow keys
		inputEl.addEventListener('keydown', (e) => {
			if(e.key === 'ArrowUp' || e.key === 'ArrowDown') {
				// Delay formatting to allow the input value to change
				formatValue()
				//setTimeout(formatValue, 0);
			}
		});

		// Listen for mouse events on up/down buttons in number input
		inputEl.addEventListener('mouseup', () => {
			// Delay formatting to allow the input value to change
			formatValue()
			//setTimeout(formatValue, 0);
		});
	}
};
